import React from 'react';
import './V1SocialProof.css';

interface V1SocialProofProps {
  theme: 'premium' | 'energetic';
}

const V1SocialProof: React.FC<V1SocialProofProps> = ({ theme }) => {
  const stats = [
    { icon: '⭐', value: '500+', label: 'Zadowolonych uczniów' },
    { icon: '📈', value: '98%', label: 'Zdawalność powyżej oczekiwań' },
    { icon: '🏆', value: '+35pkt', label: 'Średni wzrost wyników' },
    { icon: '⚡', value: '8 tyg', label: 'Do sukcesu' }
  ];

  return (
    <section className="v1-social-proof v1-section">
      <div className="v1-container">
        <div className="v1-social-proof-grid">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="v1-stat-card v1-glass v1-animate-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="v1-stat-icon">{stat.icon}</div>
              <div className="v1-stat-value v1-accent-text">{stat.value}</div>
              <div className="v1-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default V1SocialProof;
